import React, { useEffect, useMemo, useState } from 'react';
import { Window, WindowActionsBar, WindowActionsEvent } from '@progress/kendo-react-dialogs';
import { MultiSelectFilterChangeEvent } from '@progress/kendo-react-dropdowns';
import { Button } from '@progress/kendo-react-buttons';
import { useNavigate, useParams } from 'react-router-dom';
import { isMobile } from 'react-device-detect';
import * as svg from '@progress/kendo-svg-icons';
import { toast } from 'react-toastify';
import { TicketApi } from '../../../../../../redux/api/TicketApi';
import { UserApi } from '../../../../../../redux/api/UserApi';
import { PartialSpinny } from '../../../../../Nav/Spinny';
import HierarchyForm from '../../../../FormControls/HierarchyForm';

const HierarchyWindow: React.FC = () => {
    const navigate = useNavigate();
    const { ticketId } = useParams();
    const [stage, setStage] = useState(isMobile ? 'FULLSCREEN' : 'DEFAULT');
    const { data: userProfile } = UserApi.useGetUserProfileQuery();
    const { data: ticket, isLoading } = TicketApi.useGetTicketQuery({ ticketId: parseInt(ticketId) });
    const [error, setError] = React.useState<string>();
    const [formState, setFormState] = useState({ isParent: false, parentCallId: 0 });
    const [updateHierarchy, { isLoading: updatingTicket }] = TicketApi.useUpdateTicketHierarchyMutation();
    const [removeHierarchy, { isLoading: removingHierarchy, error: removeError }] = TicketApi.useRemoveTicketHierarchyMutation();

    //Set the ticket details into the formstate
    useEffect(() => {
        if (ticket)
            setFormState({ isParent: ticket.Is_Parent, parentCallId: ticket.Parent_Call_Id > 0 ? ticket.Parent_Call_Id : null });
    }, [ticket]);

    //navigate back when the winow is closed
    const onStageChange = (e: WindowActionsEvent) => {
        //setVisible(false);
        setStage(e.state)
    }

    const onWindowClose = () => {
        navigate('/ticket/' + ticketId);
    }

    const handleParentChange = (event) => {
        setError(null);
        //console.log('handleParentChange', event)
        setFormState((s) => { return { ...s, isParent: event.value, parentCallId: null } });
    };

    //Make child
    const handleChildChange = (event) => {
        setError(null);
        //console.log('handleChildChange', event)
        setFormState((s) => { return { ...s, isParent: false, parentCallId: event ? event.value : 0 } });

    };
    const onTicketSelected = (Id?: number) => {
        setError(null);
        //console.log('onTicketSelected', Id)
        setFormState((s) => { return { ...s, parentCallId: Id } });
    };

    const handleRemove = () => {
        setFormState((s) => { return { ...s, isParent: null, parentCallId: null } });
    }

    const saveChanges = () => {
        console.log('saveChanges', formState);
        setError(null);

        //Child but no parent saelected
        if (!formState.isParent && formState.parentCallId === 0) {
            setError(`Please select a parent ${userProfile?.Phrases.CallPhrase} to make this a child`);
            return;
        }

        if (!formState.isParent && !formState.parentCallId) {
            removeHierarchy({ ticketId: parseInt(ticketId) }).unwrap().then((huh) => {
                onWindowClose();
            }).catch((e) => {
                toast.error('Error removing hierarchy');
                console.error(e);
            });
        } else {
            updateHierarchy({ ticketId: parseInt(ticketId), info: { Is_PArent: formState.isParent, Parent_Ticket_Id: formState.parentCallId } }).unwrap().then(() => {
                onWindowClose();
            });
        }
    }


    if (!userProfile?.Features.Call_Hierarchy) return <></>;

    return (
        <div>
            <Window modal={true} className='cool-window' minimizeButton={() => null} title={<><img src='./images/parent-child.png' className='mr-2' />{userProfile?.Phrases.CallPhrase} Hierarchy{formState?.isParent ? ': Parent' : formState?.parentCallId ? `: Child to ${formState?.parentCallId}` : ''}</>} onClose={onWindowClose} initialHeight={580} initialWidth={Math.min(1200, window.innerWidth)} stage={stage} onStageChange={onStageChange} >
                <div className='position-relative'>
                    <div id='error-summary'>
                        {error && <div className={"k-messagebox k-messagebox-error"}>{error}</div>}
                        {/* Validation */}
                        {removeError?.["data"] && removeError?.["data"] && (
                            <div className={"k-messagebox k-messagebox-error"}>
                                {removeError["data"]?.Message || removeError["data"]}
                            </div>)}
                    </div>
                    {(isLoading || updatingTicket || removingHierarchy) && <PartialSpinny />}
                    <HierarchyForm ticketId={ticket?.ID} isParent={formState?.isParent} parentCallId={formState?.parentCallId} onRemoveHierarchy={handleRemove} onChildChange={handleChildChange} onParentChange={handleParentChange} onTicketSelected={onTicketSelected} />    </div>
                <WindowActionsBar>
                    <Button onClick={saveChanges} svgIcon={svg.saveIcon} type='submit' className='justify-content-end p-2' style={{ marginTop: '20px', color: '#fff', backgroundColor: userProfile?.Nav_Hex_Color }}>
                        Save
                    </Button>
                    <Button fillMode='outline' onClick={() => onWindowClose()} svgIcon={svg.cancelIcon} className='justify-content-end p-2' style={{ marginTop: '20px' }}>
                        Cancel
                    </Button>
                </WindowActionsBar>
            </Window>
        </div>
    );
};

export default HierarchyWindow;